let isSafari = navigator.vendor.match(/apple/i) && !navigator.userAgent.match(/crios/i) && !navigator.userAgent.match(/fxios/i) && !navigator.userAgent.match(/Opera|OPT\//);

if (isSafari) {
	document.querySelector('body').classList.add('safari');
} else {
	// Other browser is used
}

// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	$(document).ready(function () {
		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover');
				$('ul.submenu', this).fadeIn(200);
			},
			function () {
				$(this).removeClass('hover');
				$('ul.submenu', this).fadeOut(200);
			}
		);

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});
		$('#CheckOut').datepicker({
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		document.querySelector('body').classList.add('loaded');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
		const teamPics = document.querySelectorAll('.team__pic');
		if (teamPics.length > 1) {
			teamPics.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					let teamIndex = Number(ele.dataset.slickIndex);
					const fullslides = document.querySelectorAll('.team__slider .team__item').length;
					if (teamIndex - 1 > fullslides) {
						teamIndex = teamIndex - fullslides;
					}
					$('.team__slider.sym-slides').slick('slickGoTo', teamIndex + 1);
				});
			});
		}
	};
})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/* Add span to all btns */
document.querySelectorAll('.btn').forEach((ele) => {
	if (!ele.querySelector('span')) {
		var actualtext = ele.textContent;
		ele.innerHTML = `<span>${actualtext}</span>`;
	}
	ele.addEventListener('click', function (evento) {
		let hrefTarget = ele.getAttribute('href');
		if (hrefTarget && hrefTarget.startsWith('#')) {
			let elemTarget = document.querySelector(hrefTarget);
			if (elemTarget && !ele.hasAttribute('data-fancybox')) {
				evento.preventDefault();
				elemTarget.classList.remove('hide');
				$('html, body').animate({ scrollTop: $(elemTarget).offset().top - 100 }, 1000);
			}
		}
	});
});

/* Header Main Nav */
/* var hambbtn = document.querySelectorAll('.header__hamburger, .header__nav-close, .hamburger__btn');
if (hambbtn) {
	hambbtn.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			ev.preventDefault();
			var menuObj = document.querySelector('.header');
			var bottomnav = document.querySelector('nav.buttons');
			if (menuObj.classList.contains('open-nav')) {
				menuObj.classList.remove('open-nav');
				bottomnav.classList.remove('open-nav');
			} else {
				menuObj.classList.add('open-nav');
				bottomnav.classList.add('open-nav');
			}
		});
	});
} */

/* New Header Main Nav */
var hambbtnNew = document.querySelectorAll('.new-header__hamburger, .new-header__nav-close, .hamburger__btn, .new-header__nav-left-flex, .new-header__nav-right, .new-header__nav-overlay');
if (hambbtnNew) {
	hambbtnNew.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			if (!ev.target.href) ev.preventDefault();

			var menuObj = document.querySelector('.new-header');
			var bottomnav = document.querySelector('nav.buttons');
			if (menuObj.classList.contains('open-nav')) {
				menuObj.classList.remove('open-nav');
				bottomnav.classList.remove('open-nav');
			} else {
				menuObj.classList.add('open-nav');
				bottomnav.classList.add('open-nav');
			}
		});
	});
}

// TABS ROOMS
//var firstTab = document.querySelector('.list__tabs__item:first-child a');
var firstTab = document.querySelector('#tab-Studios a');
if (!firstTab) {
	firstTab = document.querySelector('.list__tabs__item:first-child button');
}

if (firstTab) {
	firstTab.classList.add('active');
	var filterFirts = firstTab.getAttribute('data-target');
	var sectionFirst = firstTab.closest('section');
	const tabHolder = document.querySelector('.list__tabs');
	const toggleBtn = document.querySelector('.list__tabs__toggle');
	sectionFirst.querySelectorAll('.list__item').forEach((allDivsFirst) => {
		allDivsFirst.classList.remove('list__item__hide');
	});

	var hideSelectorsFirst = '.list__item:not(' + filterFirts + ')';
	sectionFirst.querySelectorAll(hideSelectorsFirst).forEach((hideDivsFirst) => {
		hideDivsFirst.classList.add('list__item__hide');
		document.querySelector('.list__ofrooms').appendChild(hideDivsFirst);
	});

	var tabbuttons = document.querySelectorAll('.list__tabs__btn');
	var tc = 0;

	for (tc; tc < tabbuttons.length; tc++) {
		tabbuttons[tc].addEventListener('click', function () {
			if (!this.classList.contains('active')) {
				tabHolder.classList.toggle('open');
				tabbuttons.forEach((tabbuttons) => {
					tabbuttons.classList.remove('active');
					tabbuttons.setAttribute('aria-selected', 'false');
				});

				this.classList.add('active');
				this.setAttribute('aria-selected', 'true');
				var filterdis = this.getAttribute('data-target');
				var section = this.closest('section');

				section.querySelectorAll('.list__item').forEach((allDivs) => {
					allDivs.classList.add('list__item__hide');
				});
				setTimeout(function () {
					if (filterdis) {
						var hideSelectors = '.list__item:not(' + filterdis + ')';
						section.querySelectorAll(hideSelectors).forEach((hideDivs) => {
							document.querySelector('.list__ofrooms').appendChild(hideDivs);
						});
						var showSelectors = '.list__item' + filterdis;
						section.querySelectorAll(showSelectors).forEach((showDivs) => {
							showDivs.classList.remove('list__item__hide');
						});
					}
				}, 700);

				//Toggle animations first quad
				var firtsQuad = document.querySelector('.list__item' + filterdis);
				firtsQuad.querySelectorAll('.animate-fade').forEach((animated) => {
					animated.classList.add('fade-in', 'visible');
				});
				firtsQuad.querySelectorAll('.lazyload').forEach((lazyitem) => {
					var srcs = lazyitem.dataset.srcset;
					lazyitem.setAttribute('src', srcs);
					lazyitem.classList.add('visible');
				});

				toggleBtn.textContent = this.textContent;
			}
		});
	}
	//Tabs on mobile
	toggleBtn.addEventListener('click', (ev) => {
		ev.preventDefault();
		tabHolder.classList.toggle('open');
	});
}

/* Menu Image Over */
var menuItems = document.querySelectorAll('.privary-navigation__item');
var menuItemPics = document.querySelectorAll('.new-header__nav-pic');
if (menuItems && window.innerWidth > 767) {
	menuItems.forEach((ele, index) => {
		ele.addEventListener('mouseover', (e) => {
			menuItemPics[index].classList.add('active');
		});
		ele.addEventListener('mouseout', (e) => {
			menuItemPics[index].classList.remove('active');
		});
	});
}

/* Location Overview */
var locationDots = document.querySelectorAll('.location-ov__pin');
if (locationDots) {
	locationDots.forEach((ele) => {
		ele.addEventListener('click', (dis) => {
			dis.preventDefault();

			$('.location-ov__slide').slick('slickGoTo', ele.dataset.index);
		});
	});
}
var locPin = document.querySelector('#locationPin0');
if (locPin) {
	locPin.classList.add('active');
}
$('.location-ov__slide').slick({
	fade: true,
	prevArrow: "<button type='button' class='slick-prev slick-arrow'><span>Previous</span></button>",
	nextArrow: "<button type='button' class='slick-next slick-arrow'><span>Previous</span></button>",
});
$('.location-ov__slide').on('beforeChange', function () {
	locationDots.forEach((pin) => {
		pin.classList.remove('active');
	});
});
$('.location-ov__slide').on('afterChange', function (a, b, c) {
	let selectorString = `#locationPin${c}`;
	document.querySelector(selectorString).classList.add('active');
});

/* Hidden Form */
const formsClose = document.querySelectorAll('.customForm__close');
if (formsClose) {
	formsClose.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			ev.preventDefault();
			let targeEle = ele.getAttribute('href');
			document.querySelector(targeEle).classList.add('hide');
		});
	});
}

/* Restaurant Menus */
document.querySelectorAll('.restaurant__btn').forEach((ele) => {
	ele.addEventListener('mouseover', function () {
		let imgref = ele.dataset.imgi;
		document.querySelectorAll('.restMenus_pic').forEach((bg) => {
			bg.classList.remove('active');
		});
		document.querySelector(imgref).classList.add('active');
	});
});

/* Amenities Icons */
const amenities = document.querySelectorAll('.amenities__list');
if (amenities) {
	amenities.forEach((ele) => {
		const icons = ele.querySelectorAll('.text ul li img');
		if (icons.length > 1) {
			ele.classList.add('with-icons');
		}
	});
}

/* Add span to all btns */
document.querySelectorAll('.goto').forEach((ele) => {
	ele.addEventListener('click', function (evento) {
		let hrefTarget = ele.getAttribute('href');
		let elemTarget = document.querySelector(hrefTarget);
		if (elemTarget) {
			evento.preventDefault();
			elemTarget.classList.remove('hide');
			$('html, body').animate({ scrollTop: $(elemTarget).offset().top - 80 }, 1000);
		}
	});
});

const tablesResp = document.querySelectorAll('.text-modules table, .text table');
if (tablesResp.length) {
	tablesResp.forEach((tablei) => {
		var tableresponsive = document.createElement('div');
		tableresponsive.classList.add('tableHold');
		tablei.parentNode.insertBefore(tableresponsive, tablei);
		tableresponsive.append(tablei);
		const ths = tablei.querySelectorAll('tr:first-child > *');
		tablei.querySelectorAll('tr + tr').forEach((row) => {
			const tds = row.querySelectorAll('td');
			let i = 0;
			for (i; i < tds.length; i++) {
				tds[i].setAttribute('data-label', ths[i].textContent);
			}
		});

		const rowHeads = tablei.querySelectorAll('tr td:first-child');
		rowHeads.forEach((ele) => {
			ele.addEventListener('click', (ev) => {
				ele.closest('tr').classList.toggle('active');
			});
		});
	});
}
// Anchor link functionality for mobile
let anchorLink = document.getElementById('anchorLink1670Room');
if (anchorLink) {
	anchorLink.addEventListener('click', function (e) {
		e.stopPropagation();
	});
}

//Custom form Dates
$('.mod-no-touchevents #id_7_1117[type="text"]').datepicker({
	onSelect: function (value, date) {
		var miniDate = new Date(value);
		$('#id_8_1117').datepicker('option', 'minDate', miniDate);
	},
});
$('.mod-no-touchevents #id_11_1117[type="text"]').datepicker({
	onSelect: function (value, date) {
		var miniDate = new Date(value);
		$('#id_12_1117').datepicker('option', 'minDate', miniDate);
	},
});

/* Submenu on mobile */
function submenu() {
	var submenuHold = document.querySelectorAll('.sub-menu__hold');
	var allsublinks = document.querySelectorAll('.sub-menu a');
	if (allsublinks.length > 1) {
		allsublinks.forEach((ele) => {
			ele.addEventListener('click', function (ev) {
				if (ele.classList.contains('active')) {
					ev.preventDefault();
				}
			});
		});
		var toggleBtn = document.querySelector('.sub-menu__toggle');
		if (toggleBtn) {
			toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
			toggleBtn.addEventListener('click', function () {
				toggleBtn.parentElement.classList.toggle('open');
			});
		}
	} else if (submenuHold.length > 0) {
		submenuHold[0].classList.add('d-none');
	}
}
submenu();

//Grayscale images
const introImages = document.querySelectorAll('.intro-content__image, .intro-content-home__image-box, .singleq-alt__figure, .list-alt__item__img');
if (introImages.length > 0) {
	introImages.forEach((el) => {
		el.addEventListener('mouseenter', (ev) => {
			el.classList.remove('visible');
		});
	});
}

/* Mobile click on reasons quad cards */
const reasonsCards = document.querySelectorAll('.reasons__item');
if (reasonsCards.length > 0) {
	reasonsCards.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			if (ev.target != this.querySelector('.reasons__buttons .btn')) {
				this.classList.toggle('active');
			}
		});
	});
}
